<mat-card class="container">
  <mat-card-header>
    <mat-toolbar color="primary" class="toolbar">
      <span class="title">Company List</span>
      <span class="spacer"></span>
      <button mat-raised-button color="accent" (click)="showInputField()">Add</button>
    </mat-toolbar>
  </mat-card-header>

  <mat-card-content>
    <div *ngIf="isAdding" class="input-container">
      <form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
        <mat-form-field appearance="outline">
          <mat-label>Company ID</mat-label>
          <input matInput formControlName="companyId">
        </mat-form-field>
      </form>

      <div class="button-group">
        <button mat-button color="warn" (click)="cancel()">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="inputForm.invalid" (click)="addCompany()">Save</button>
      </div>
    </div>

    <mat-list *ngIf="items.length > 0">
      <mat-list-item *ngFor="let item of items; let i = index">
        <div class="company-list-item">
          <span>{{item}}</span>
          <button mat-icon-button color="warn" (click)="removeCompany(item)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
